export default __webpack_public_path__ + "static/media/info.5ae291a7.svg";